export default [
  {
    title: 'Bienvenida',
    element: '.none',
    text: 'Bienvenido a {{wlName}}, tu plataforma de intercambio de imágenes médicas. En este tour te ayudaremos a empezar a utilizarla.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'Resultados médicos',
    element: '.icons-layout',
    text: 'Aquí podrá ver todas las carpetas, documentos y pruebas médicas que le hayan compartido.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'Aún no hay resultados',
    element: '.empty-folder',
    text: 'Parece que aún no han subido sus resultados. Este proceso puede tardar varios días.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  },
  {
    title: 'Ver los archivos',
    element: '.icon-wrapper-file',
    text: 'Puede hacer <strong>doble clic</strong> para entrar en carpetas o abrir archivos.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/es-ES/guestTour.js